import { render, staticRenderFns } from "./set-neg-product-modal.vue?vue&type=template&id=796d358a&scoped=true&"
import script from "./set-neg-product-modal.vue?vue&type=script&lang=js&"
export * from "./set-neg-product-modal.vue?vue&type=script&lang=js&"
import style0 from "./set-neg-product-modal.vue?vue&type=style&index=0&id=796d358a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796d358a",
  null
  
)

export default component.exports